/**
 * Created by sswaminathan on 1/26/22
 * File: StatusCalculator
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { cloneElement, useCallback, useMemo } from 'react'
import { ARRAY } from '../common/utils'

const StatusCalculator = (props: any) => {

  const { children, instanceData, isIndividual } = props

  const PROVISIONING_STATUSES: {[index: string]: number} = useMemo(() => {
    return {
      'error': 0,
      'initializing': 3,
      'provisioning': 2,
      'complete': 1
    }
  }, [])


  const getTotalPercent = useCallback(() => {
    const instances = instanceData?.filter((instance: any) => instance?.provisioning_status !== 'error')
    if (ARRAY.hasArray(instances)) {
      let totalPercent = 0
      for (const instance of instances) {
        const instancePercent = 100 / instances?.length
        const denominator = PROVISIONING_STATUSES[instance.provisioning_status]
        if (denominator > 0) {
          const currentPercent = instancePercent / denominator
          totalPercent += currentPercent
        }
      }
      return Math.ceil(totalPercent)
    }
    return 0
  }, [instanceData, PROVISIONING_STATUSES])

  const getIndividualPercent = useCallback(() => {
    if (instanceData?.length > 1) return getTotalPercent()
    if (instanceData) {
      const denominator = PROVISIONING_STATUSES[instanceData[0]?.provisioning_status || 0]
      if (denominator > 0) {
        const currentPercent = 100 / denominator
        return Math.ceil(currentPercent)
      }
    }
    return 0
  }, [getTotalPercent, instanceData, PROVISIONING_STATUSES])

  return cloneElement(children, { progress: isIndividual ? getIndividualPercent() : getTotalPercent() })

}
export default StatusCalculator
